const Constants = {
    API_RESPONSE_ERROR_FALSE: false,
    API_RESPONSE_ERROR_TRUE: true,
}

export default Constants;